import { Header } from "../components/Header";
import { useTrackPageView } from "../hooks/useTrackPageView";
import { useClientTranslations } from "../lib/i18n/client";
import styles from "./PlaceholderPage.module.css";

interface PlaceholderPageProps {
	titleKey: string;
	analyticsName: string;
}

export function PlaceholderPage({
	titleKey,
	analyticsName,
}: PlaceholderPageProps) {
	const { t } = useClientTranslations("common");
	useTrackPageView(analyticsName);

	return (
		<div className={styles.wrapper}>
			<Header />
			<main className={styles.main}>
				<h1 className={styles.title}>{t(titleKey)}</h1>
			</main>
		</div>
	);
}
